import {cn} from '../../lib/utils';
import {Tabs} from '../Tabs';

import type {TabItem} from '../Tabs/tab.types';

interface ModalTabsHeaderProps {
  tabs: TabItem[];
  value?: string;
  onValueChange?: (value: string) => void;
  className?: string;
}

export function ModalTabsHeader({tabs, value, onValueChange, className}: ModalTabsHeaderProps) {
  return (
    <div
      data-slot="modal-tabs-header"
      className={cn(
        // negate DialogContent's p-6 so the header is flush with modal edges
        '-mx-6 -mt-6',
        'flex items-stretch border-b border-border-subtle',
        className
      )}
    >
      <Tabs
        tabs={tabs}
        value={value}
        defaultValue={value}
        onValueChange={onValueChange}
        variant="secondary"
        listClassName="border-b-0 gap-0"
        triggerClassName="px-6 py-4"
      />
    </div>
  );
}
